import { createContext, useContext } from "react";
import Lenis from "lenis";

export const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export const P2P_URL = "https://p2p.resiliencebrothers.com";

let lenis = null;

export const startLenis = () => {
  lenis = new Lenis({ lerp: 0.085 });
  let id;
  const raf = (time) => {
    lenis.raf(time);
    id = requestAnimationFrame(raf);
  };
  id = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(id);
    lenis.destroy();
    lenis = null;
  };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
